import React, { Component } from 'react';
import { Modal, message, Button } from 'antd';
import './shModal.scss';

class ShModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      selAdArray: null,
      otherAdItem: {
        index: 7,
        diamondAmount: 0,
        price: '',
      },
      loading: false,
      areaListType: [], // 地区列表
      areaType: null, // 地区选择
      payList: null, // 支付方式列表
      payId: null, // 选中的支付方式
      // payType: 2, //微信2 支付宝1
      payType: 5, //h5 微信5 支付宝7
      action: 1, //1钱包 2语聊大厅 3开箱 4下单 5买背景
      areaCharConfig: [],
      isRechargeAgreement: true, // 是否勾选充值协议
      firstChargeTime: 0, // 首充倒计时
      tipVisible: false,
      isAgree: true,
      isAgree2: true,
      isAgree3: false,
    };
  }

  showTipModal = () => {
    this.setState({ tipVisible: true });
  };

  hideTipModal = () => {
    this.setState({ tipVisible: false });
  };

  isAgreeProtocol = () => {
    console.log(33333);

    this.setState({
      isAgree: !this.state.isAgree,
    });
  };

  isAgreeProtocol2 = () => {
    this.setState({
      isAgree2: !this.state.isAgree2,
    });
  };

  isAgreeProtocol3 = () => {
    this.setState({
      isAgree3: !this.state.isAgree3,
    });
  };

  confirmPay = () => {
    const { isAgree, isAgree2, isAgree3 } = this.state;
    const { toShPay } = this.props;
    if (!isAgree) {
      message.warning('请先同意钻石充值服务协议');
      return;
    }

    if (!isAgree2) {
      message.warning('请先同意实名认证服务协议');
      return;
    }

    if (isAgree3) {
      window.localStorage.setItem('isShTips', true);
    }

    toShPay();
  };

  render() {
    const { tipVisible, isAgree, isAgree2, isAgree3 } = this.state;
    return (
      <span>
        <Modal
          open={false}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="充值提示"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="560px"
          onCancel={this.hideTipModal}
          zIndex={1006}
        >
          <div className="sh-tips-container">
            <p className="sh-tips" style={{ marginTop: '20px' }}>
              您即将进入四合网咖用户专属充值通道进行充值，为了保证您的资金安全，请确认是您本人操作：{' '}
            </p>
            <p className="sh-tips" style={{ marginTop: '25px' }}>
              温馨提示：
            </p>
            <p className="sh-tips">
              1.充值成功后，带带钻石的到账可能存在延迟1分钟，请耐心等待。
            </p>
            <p className="sh-tips">
              2.由于您使用的四合网咖专属充值通道，若您充值成功，未正常到账钻石，请联系四合网咖管理员。
            </p>
            <p className="sh-tips">
              3.您充值成功后，请到您的带带账号“钱包”查看钻石余额，您在带带内的一切消费将以带带的消费货币“钻石”进行。若订单发生退款，将以“钻石”形式退回到您的钱包。路径：点击右上角个人头像-我的钱包。
            </p>
            <p className="sh-tips">
              4.为了保证您的账号安全，部分功能将需要您进行实名认证，平台将保证您的个人隐私。
            </p>
            <div className="agreement">
              <span onClick={this.isAgreeProtocol} className="radio">
                {isAgree && <i />}
              </span>
              <span className="desc">
                我已阅读并同意
                <span>《钻石充值服务协议》</span>
              </span>
            </div>
            <div className="agreement">
              <span onClick={this.isAgreeProtocol2} className="radio">
                {isAgree2 && <i />}
              </span>
              <span className="desc">
                我已阅读并同意
                <span>《实名认证服务协议》</span>
              </span>
            </div>
            <div className="reg-actions">
              <Button  className="daidai-btn-primary" onClick={this.confirmPay}>
                确认充值
              </Button>
            </div>
            <div
              className="agreement"
              style={{
                textAlign: 'center',
                margin: '10px auto',
                paddingBottom: '30px',
              }}
            >
              <span onClick={this.isAgreeProtocol3} className="radio">
                {isAgree3 && <i className="red-check" />}
              </span>
              <span className="desc">下次不再提示</span>
            </div>
          </div>
        </Modal>
      </span>
    );
  }
}

export default ShModal;
